"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WindowPropertyFactoryFromJS = exports.WindowPropertyFactory = void 0;
const immutable_1 = require("immutable");
const IWindowChild_1 = require("./IWindowChild");
exports.WindowPropertyFactory = (0, immutable_1.Record)({
    activeItemIndex: null,
    height: null,
    id: null,
    isClosable: null,
    position: null,
    props: null,
    scrollbars: null,
    title: null,
    subTitle: null,
    width: null,
    icon: null,
    animationClass: '',
    child: (0, IWindowChild_1.WindowChildFactory)(),
    overlayWhenChildVisible: null
});
const WindowPropertyFactoryFromJS = function (data) {
    return data
        ? (0, exports.WindowPropertyFactory)(Object.assign(Object.assign({}, data), { child: (0, IWindowChild_1.WindowChildFactoryFromJS)(data.child) }))
        : null;
};
exports.WindowPropertyFactoryFromJS = WindowPropertyFactoryFromJS;
//# sourceMappingURL=IWindowProperty.js.map